module.exports = __webpack_public_path__ + "img/icons-20-info.2c9eadaa.svg";